import React, { useState } from "react";

function App() {
  // Login
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  // Employee data
  const [employees, setEmployees] = useState([]);
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [stateName, setStateName] = useState("");
  const [active, setActive] = useState(true);
  const [profile, setProfile] = useState(null);
  const [editId, setEditId] = useState(null);

  // 🔍 Search & Filter states
  const [search, setSearch] = useState("");
  const [filterGender, setFilterGender] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");

  // Login logic
  const handleLogin = () => {
    if (username === "admin" && password === "admin") {
      setIsLoggedIn(true);
    } else {
      alert("Invalid credentials");
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUsername("");
    setPassword("");
  };

  // Add / Update employee
  const handleSubmit = () => {
    if (!name || !gender || !dob || !stateName) {
      alert("Fill all fields");
      return;
    }

    if (editId) {
      setEmployees(
        employees.map((e) =>
          e.id === editId
            ? { ...e, name, gender, dob, state: stateName, active, profile }
            : e
        )
      );
      setEditId(null);
    } else {
      setEmployees([
        ...employees,
        {
          id: employees.length + 1,
          name,
          gender,
          dob,
          state: stateName,
          active,
          profile,
        },
      ]);
    }

    setName("");
    setGender("");
    setDob("");
    setStateName("");
    setActive(true);
    setProfile(null);
  };

  const handleEdit = (emp) => {
    setEditId(emp.id);
    setName(emp.name);
    setGender(emp.gender);
    setDob(emp.dob);
    setStateName(emp.state);
    setActive(emp.active);
    setProfile(emp.profile);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete?")) {
      setEmployees(employees.filter((e) => e.id !== id));
    }
  };

  const handlePrint = (emp) => {
    const win = window.open("", "", "width=400,height=400");
    win.document.write(`
      <pre>
ID: ${emp.id}
Name: ${emp.name}
Gender: ${emp.gender}
DOB: ${emp.dob}
State: ${emp.state}
Status: ${emp.active ? "Active" : "Inactive"}
      </pre>
    `);
    win.print();
  };

  // 🔍 FILTER LOGIC (IMPORTANT)
  const filteredEmployees = employees.filter((emp) => {
    const matchName = emp.name.toLowerCase().includes(search.toLowerCase());
    const matchGender =
      filterGender === "All" || emp.gender === filterGender;
    const matchStatus =
      filterStatus === "All" ||
      (filterStatus === "Active" && emp.active) ||
      (filterStatus === "Inactive" && !emp.active);

    return matchName && matchGender && matchStatus;
  });

  const activeCount = employees.filter((e) => e.active).length;
  const inactiveCount = employees.length - activeCount;

  // LOGIN PAGE
  if (!isLoggedIn) {
    return (
      <div style={{ padding: 30 }}>
        <h2>Login</h2>
        <input
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <br /><br />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <br /><br />
        <button onClick={handleLogin}>Login</button>
      </div>
    );
  }

  // DASHBOARD
  return (
    <div style={{ padding: 20 }}>
      <h2>Employee Management Dashboard</h2>
      <button onClick={handleLogout}>Logout</button>

      <p>Total Employees: {employees.length}</p>
      <p>Active: {activeCount} | Inactive: {inactiveCount}</p>

      <hr />

      <h3>{editId ? "Edit Employee" : "Add Employee"}</h3>

      <input placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} /><br /><br />

      <select value={gender} onChange={(e) => setGender(e.target.value)}>
        <option value="">Select Gender</option>
        <option>Male</option>
        <option>Female</option>
      </select><br /><br />

      <input type="date" value={dob} onChange={(e) => setDob(e.target.value)} /><br /><br />

      <select value={stateName} onChange={(e) => setStateName(e.target.value)}>
        <option value="">Select State</option>
        <option>Odisha</option>
        <option>Mizoram</option>
        <option>Manipur</option>
        <option>Telangana</option>
        <option>Andhra Pradesh</option>
      </select><br /><br />

      <input type="file" onChange={(e) => setProfile(URL.createObjectURL(e.target.files[0]))} /><br /><br />

      <label>
        <input type="checkbox" checked={active} onChange={() => setActive(!active)} /> Active
      </label><br /><br />

      <button onClick={handleSubmit}>
        {editId ? "Update Employee" : "Add Employee"}
      </button>

      <hr />

      {/* 🔍 SEARCH & FILTER */}
      <h3>Search & Filter</h3>
      <input
        placeholder="Search by name"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <select value={filterGender} onChange={(e) => setFilterGender(e.target.value)}>
        <option value="All">All Genders</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
      </select>

      <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
        <option value="All">All Status</option>
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>

      <hr />

      {/* EMPLOYEE LIST */}
      <h3>Employee List</h3>
      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>ID</th>
            <th>Profile</th>
            <th>Name</th>
            <th>Gender</th>
            <th>DOB</th>
            <th>State</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredEmployees.map((emp) => (
            <tr key={emp.id}>
              <td>{emp.id}</td>
              <td>{emp.profile && <img src={emp.profile} width="40" alt="" />}</td>
              <td>{emp.name}</td>
              <td>{emp.gender}</td>
              <td>{emp.dob}</td>
              <td>{emp.state}</td>
              <td>{emp.active ? "Active" : "Inactive"}</td>
              <td>
                <button onClick={() => handleEdit(emp)}>Edit</button>{" "}
                <button onClick={() => handlePrint(emp)}>Print</button>{" "}
                <button onClick={() => handleDelete(emp.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default App;